import { combineReducers } from "redux-immutable";

export default combineReducers({
  access: require("./data").default,
  list: require("./list").default,
});
